import "../../js/helper/Helper.js";

const HelperObject: HelperType = window.Helper;

export {HelperObject as Helper};

